import { render, staticRenderFns } from "./PPTOutline.vue?vue&type=template&id=28999648&scoped=true&"
import script from "./PPTOutline.vue?vue&type=script&lang=js&"
export * from "./PPTOutline.vue?vue&type=script&lang=js&"
import style0 from "./PPTOutline.vue?vue&type=style&index=0&id=28999648&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28999648",
  null
  
)

export default component.exports